import React from 'react';
import styled from 'styled-components';
import useHandleWaitlistProduct from '../../../../../../hooks/useHandleWaitlistProduct';

const Wrapper = styled.button`
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
  color: white;
  height: 50px;
  border: none;
  width: 250px;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 0.9)};

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  /* identical to box height, or 144% */

  letter-spacing: 0.04em;

  color: #ffffff;

  &:hover {
    transition: all 0.3s;
    opacity: 0.8;
  }

  @media (max-width: 400px) {
    width: 60%;
  }
`;

function WaitlistButton({ productId }) {
  const [
    handleClick,
    checkIfOnWaitlist,
    { loading }
  ] = useHandleWaitlistProduct();

  return (
    <>
      <Wrapper onClick={() => handleClick(productId)} disabled={loading}>
        {checkIfOnWaitlist(productId)
          ? 'Remove from Waitlist'
          : 'Add to Waitlist'}
      </Wrapper>
    </>
  );
}

export default WaitlistButton;
